import type { Direction } from '../game/state';
import type { InputManager } from './input-manager';
export function bindTouch(root:HTMLElement,canvas:HTMLCanvasElement,input:InputManager,swipe:()=>boolean,onGesture:()=>void):void{
  for(const button of root.querySelectorAll<HTMLButtonElement>('[data-direction]')){
    button.addEventListener('pointerdown',e=>{
      e.preventDefault();onGesture();button.setPointerCapture(e.pointerId);
      button.classList.add('pressed');input.press(`pointer-${e.pointerId}`,button.dataset.direction as Direction);
    });
    const release=(e:PointerEvent):void=>{input.release(`pointer-${e.pointerId}`);button.classList.remove('pressed');};
    for(const event of ['pointerup','pointercancel','lostpointercapture','pointerleave'])button.addEventListener(event,release as EventListener);
    // Keyboard and assistive activation (pointer click is already handled).
    button.addEventListener('click',e=>{if(e.detail===0){onGesture();input.tap(button.dataset.direction as Direction);}});
    button.addEventListener('contextmenu',e=>e.preventDefault());
  }
  let gesture:{id:number;x:number;y:number;at:number}|null=null;
  canvas.addEventListener('pointerdown',e=>{
    if(!swipe())return;e.preventDefault();onGesture();canvas.setPointerCapture(e.pointerId);
    gesture={id:e.pointerId,x:e.clientX,y:e.clientY,at:performance.now()};
  });
  canvas.addEventListener('pointerup',e=>{
    if(!gesture||e.pointerId!==gesture.id)return;
    const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y,elapsed=performance.now()-gesture.at;gesture=null;
    if(Math.max(Math.abs(dx),Math.abs(dy))<14||elapsed>1200)return;
    input.tap(Math.abs(dx)>Math.abs(dy)?dx>0?'right':'left':dy>0?'down':'up');
  });
  canvas.addEventListener('pointercancel',()=>{gesture=null;});
}
